/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useField } from 'formik';
import './ControltQuantity.scss';

const ControltQuantity = React.forwardRef(
  (
    {
      onChange,
      mask,
      ...props
    },
  ) => {
    const [field, meta, helpers] = useField(props);


    const inputValue = field.value;
    const minValue = Number(props.min);
    const maxValue = Number(props.max);
    const stopServiceForMax = inputValue === maxValue;
    const stopServiceForMin = inputValue === minValue;

    const getEventValue = (e) => {
      const { value } = e.target;
      const evt = {
        ...e,
        target: {
          ...e.target,
          value: value ? Number(value) : value
        }
      };
      return evt;
    };

    const handleChange = (e) => {
      const evt = getEventValue(e);
      if (mask) {
        const { value } = evt.target;
        const newValue = typeof mask === 'function' ? mask(value) : mask?.apply(value);
        evt.target.value = newValue;
        e.target.value = newValue;
      }
      if (Number(e.target.value) < 0 || Number(e.target.value) > maxValue) {
        return false;
      }
      field.onChange(e);
      if (onChange) onChange(evt);
    };

    const handleChangeNumberValue = useCallback(
      (numberType) => {
        const currentValue = Number(field.value);

        const increment = () => {
          const incrementValue =
            Number.isNaN(currentValue) || currentValue < 1
              ? 1
              : maxValue
              ? currentValue + 1 <= maxValue
                ? currentValue + 1
                : currentValue
              : currentValue + 1;
          return incrementValue;
        };

        const decrease = () => {
          const decreaseValue =
            Number.isNaN(currentValue) || currentValue < 1
              ? 0
              : minValue
              ? currentValue - 1 >= minValue
                ? currentValue - 1
                : currentValue
              : currentValue - 1;
          helpers.setValue(decreaseValue);
          return decreaseValue;
        };
        const value = numberType === 'increment' ? increment() : decrease();
        if (onChange) onChange({ target: { value } });
      },
      [field, helpers, onChange]
    );

    return (
      <div className='d-flex align-items-center justify-content-center'>
        {props.label && <span style={{
          padding: '0 0.3rem',
          fontSize: '0.9rem',
          fontWeight: 'normal',
          color: 'rgb(180, 175, 175)',
        }} >{props.label}</span>}

        <div className='d-flex justify-content-center align-items-center'
          style={{
            border: '1px solid rgb(180, 175, 175)',
            borderRadius: '100px',
            width: '75px',
            height: '28px',
            fontWeight: 'normal',
            paddingTop: '0.1rem',
            color: 'rgb(180, 175, 175)',
            fontSize: '1rem',                
          }}
        >
          <div
            onClick={() => stopServiceForMin ? null : handleChangeNumberValue('decrease')}
            role="button"
            className='cursor-pointer'
            style={{ fontSize: '1rem !important', padding: '3px' }} 
          >-</div>

          <div className='text-align-center' style={{ margin: '0 0.6rem', }}>{inputValue}</div>
          
          <div
            role="button"
            className='cursor-pointer'
            style={{ fontSize: '1rem !important', padding: '3px'}}
            onClick={() => stopServiceForMax ? null : handleChangeNumberValue('increment') }
            >+</div>
          
          <input type="number" className='d-none' onChange={handleChange} name={props.name} value={inputValue} min={props.min} max={props.max} />
        </div>
      </div>
    );
  }
);

ControltQuantity.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  onChange: PropTypes.func,
};

export default ControltQuantity;
